import React, {useEffect, useState, useRef} from 'react';
import {motion, useInView} from 'framer-motion';

import Button from '../common/Button';
import SmallCard from './SmallCard';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import {useMovePage} from '../../hooks/useMovePage';
import styles from './styles/main-06.module.css';

import {ReactComponent as TableImg} from '../../assets/main06/table.svg';
import {ReactComponent as ChartImg} from '../../assets/main06/chart.svg';
import {ReactComponent as MultiImg} from '../../assets/main06/multi.svg';
import {ReactComponent as RecommandImg} from '../../assets/main06/recommand.svg';

const easeInMotion = {
    ease: 'easeIn',
    duration: 0.8
};

const cardMotion = {
    initial: { opacity: 0, y: 100 },
    animate: { opacity: 1, y: 0 },
    transition: { type: 'spring', stiffness: 300, damping: 40 }
};

export default function Main06() {
    const mobile = useMediaQuery('(max-width: 768px)');
    const mobileSmall = useMediaQuery('(max-width: 480px)');
    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');

    const movePage = useMovePage();

    const ref = useRef(null);

    const isInView = useInView(ref, {
        once: true,
        amount: mobile ? 0.1 : 0.2,
        margin: mobileMedium ? '-10px 0px' : '-100px 0px'
    });

    const [step, setStep] = useState(0);

    useEffect(() => {
        if (isInView) {
            const timer1 = setTimeout(() => setStep(1), 0); // 제목
            const timer2 = setTimeout(() => setStep(2), 400); // table 카드
            const timer3 = setTimeout(() => setStep(3), 1000); // chart 카드
            const timer4 = setTimeout(() => setStep(4), 1600); // 두 번째 boxCard

            return () => {
                [timer1, timer2, timer3, timer4].forEach(clearTimeout);
            };
        }
    }, [isInView]);

  return (
    <div className={styles.wrapper}>
        <div className={styles.container} ref={ref}>
            <motion.p
                initial={{ opacity: 0 }}
                animate={isInView ? { opacity: 1 } : { opacity: 0 }}
                transition={easeInMotion}
            >
                무엇이든 질문하세요!
            </motion.p>
            <div className={styles.containerCard}>
                <div className={styles.boxCard}>
                    <motion.div
                        initial={cardMotion.initial}
                        animate={step >= 2 ? cardMotion.animate : cardMotion.initial}
                        transition={cardMotion.transition}
                    >
                        <SmallCard 
                            type='table'
                            title='표 형식의 답변'
                            subTitle='복잡한 DB 정보는 표 형식으로 답변해 드려요'
                            Image={TableImg}
                        />
                    </motion.div>
                    <motion.div
                        initial={cardMotion.initial}
                        animate={step >= 3 ? cardMotion.animate : cardMotion.initial}
                        transition={cardMotion.transition}
                    >
                        <SmallCard 
                        type='chart'
                        title='맞춤형 그래프 설정'
                        subTitle='그래프 설정을 통해 원하는 방식으로 정보를 습득하세요'
                        Image={ChartImg}
                    />
                    </motion.div>
                </div>
                <motion.div
                    className={styles.boxCard}
                    initial={cardMotion.initial}
                    animate={step >= 4 ? cardMotion.animate : cardMotion.initial}
                    transition={cardMotion.transition}
                >
                    <SmallCard 
                        type='multi'
                        title='한 번의 질문으로 여러 개의 답변 제공'
                        subTitle='매일 보는 데이터를 한 번의 질문으로 조회해 보세요'
                        Image={MultiImg}
                    />
                    <SmallCard 
                        type='recommand'
                        title='모호한 질문도 정확하게'
                        subTitle='모호한 질문은 선택지를 통해 정확하게 만들어요'
                        Image={RecommandImg}
                    />
                </motion.div>
            </div>
            <Button
                text='DARVIS는 이렇게 답해요 →'
                width={mobileSmall ? '204px': '320px'}
                height={mobileSmall ? '38px': '58px'}
                padding='8px 12px'
                backgroundColor='#825DFC'
                border='none'
                borderRadius={mobileSmall ? '10px': '15px'}
                fontSize={mobileSmall ? '16px': '24px'}
                fontWeight={mobileSmall ? '600': '700'}
                textColor='#FFF'
                onClick={() => movePage('/service/chat')}
            />            
        </div>
    </div>
  );
}
